import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './SingleProject.css';


import { BsGithub } from 'react-icons/bs';

const SingleProject = () => {
    
const {projectId} = useParams();
// console.log(projectId);

const [projects, setProjects] = useState({});

 useEffect( ()=>{
    fetch(`/Projects.json`)
     .then(res=> res.json())
     .then(data=> {
        const found = data.filter(project => project.id === parseInt(projectId));
        setProjects(found[0]);
        console.log(found[0]);
     })
},[])

    return (
        <div className="container pb-5 pt-5 mt-5">
           <div className="row text-white singleProject mt-3 mb-5">
            <div className="col-md-8 col-sm-12 p-2">   
             <img data-aos="fade-up-right" className="img-fluid" style={{width: '100%', height: '95vh'}} src={projects.tumbl} alt=""/>
            </div>
             <div className="col-md-4 col-sm-12 p-2" style={{'fontSize': '14px'}}> 
               <div data-aos="fade-up-left" className="text-start" style={{ 'textAlign': 'justify'}}>
                 <h2 className="pb-3">Project Information</h2> 
                 <h5 className="">{projects.name}</h5>
                 <p>Category: <strong className="purple">Forend Design, Backend Devlopment</strong></p> 
                 <p>Client: <strong className="purple">{projects.client}</strong></p>
                 <p>Date: <strong className="purple">{projects.date}</strong></p> 
                 <p>Project URL: <a href={projects.projectLink} target="_blank" > View kProject</a></p> 
                 <p>GitHub:<a href={projects.gitlink} target="_blank" > View Source Code</a></p> 
                 <p className="mt-3" style={{fontSize: '15px', color: 'white'}}>Technologies: <strong className="purple">{projects?.shortDes}</strong> </p>
                 <div class="pt-5">
                   <p>{projects.des}</p>
                 </div>
               </div>
            </div>
          </div>
        </div>
    );
};

export default SingleProject;